var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper", class: { "nav-open": _vm.$sidebar.showSidebar } },
    [
      _c(
        "side-bar",
        {
          attrs: {
            logo: "static/img/app-icons/icon-34.png",
            title: "Admin Panel"
          },
          scopedSlots: _vm._u([
            {
              key: "links",
              fn: function(props) {
                return [
                  _c("sidebar-item", {
                    attrs: {
                      link: {
                        name: "Dashboard",
                        icon: "nc-icon nc-chart-pie-35",
                        path: "/dashboard"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("sidebar-item", {
                    attrs: {
                      link: {
                        name: "Penjualan",
                        icon: "nc-icon nc-cart-simple",
                        path: "/penjualan"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("sidebar-item", {
                    attrs: {
                      link: {
                        name: "Pembelian",
                        icon: "nc-icon nc-delivery-fast",
                        path: "/pembelian"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("sidebar-item", {
                    attrs: {
                      link: {
                        name: "Barang",
                        icon: "nc-icon nc-backpack",
                        path: "/barang"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "sidebar-item",
                    {
                      attrs: {
                        link: {
                          name: "Stok",
                          icon: "nc-icon nc-cloud-upload-94"
                        }
                      }
                    },
                    [
                      _c("sidebar-item", {
                        attrs: {
                          link: {
                            name: "Stok",
                            path: "/stok",
                            icon: ["fa", "sign-out-alt"]
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("sidebar-item", {
                        attrs: {
                          link: {
                            name: "Transaksi Stok",
                            path: "/transaksi-stok",
                            icon: ["fa", "layer-group"]
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("sidebar-item", {
                    attrs: {
                      link: {
                        name: "Barang terlaris",
                        icon: "nc-icon nc-favourite-28",
                        path: "/item-terlaris"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("sidebar-item", {
                    attrs: {
                      link: {
                        name: "Laporan Penjualan",
                        icon: "nc-icon nc-paper-2",
                        path: "/laporan"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "sidebar-item",
                    {
                      attrs: {
                        link: {
                          name: "Pengaturan",
                          icon: "nc-icon nc-settings-gear-64"
                        }
                      }
                    },
                    [
                      _c("sidebar-item", {
                        attrs: {
                          link: {
                            name: "sablon",
                            path: "/pengaturan/sablon",
                            icon: ["fa", "print"]
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("sidebar-item", {
                        attrs: {
                          link: {
                            name: "Kategori",
                            path: "/pengaturan/kategori",
                            icon: ["fa", "boxes"]
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("sidebar-item", {
                        attrs: {
                          link: {
                            name: "Warna",
                            path: "/pengaturan/warna",
                            icon: ["fa", "fill-drip"]
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("sidebar-item", {
                        attrs: {
                          link: {
                            name: "Ukuran",
                            path: "/pengaturan/ukuran",
                            icon: ["fa", "infinity"]
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("sidebar-item", {
                        attrs: {
                          link: {
                            name: "Kategori Pelanggan",
                            path: "/pengaturan/kategori-pelanggan",
                            icon: ["fa", "boxes"]
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("sidebar-item", {
                        attrs: {
                          link: {
                            name: "Pelanggan",
                            path: "/pengaturan/pelanggan",
                            icon: ["fa", "user-friends"]
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("sidebar-item", {
                        attrs: {
                          link: {
                            name: "Supplier",
                            path: "/pengaturan/supplier",
                            icon: ["fa", "parachute-box"]
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("sidebar-item", {
                        attrs: {
                          link: {
                            name: "Pengguna",
                            path: "/pengaturan/pengguna/owner",
                            icon: ["fa", "user-tie"]
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("sidebar-item", {
                        attrs: {
                          link: {
                            name: "Web Config",
                            path: "/pengaturan/web-config",
                            icon: ["fa", "cogs"]
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [_c("mobile-menu")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main-panel" },
        [
          _c("top-navbar", {
            ref: "topNavBar",
            on: {
              clickNotification: _vm.readNotification,
              openAllNotification: _vm.openNotificationSideWindow,
              closeAllNotification: _vm.closeNotificationSideWindow
            }
          }),
          _vm._v(" "),
          _c("dashboard-content", {
            nativeOn: {
              click: function($event) {
                return _vm.toggleSidebar($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("side-notification", {
        ref: "sideNotification",
        on: { click: _vm.readNotification }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a86c5310", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a86c5310","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Layout/DashboardLayout.vue
// module id = MhCw
// module chunks = 4